var map = {
	"./cy/main.yml": 32,
	"./de/main.yml": 33,
	"./en/main.yml": 34,
	"./es/main.yml": 35,
	"./eu/main.yml": 36,
	"./fr/main.yml": 37,
	"./hr/main.yml": 38,
	"./it/main.yml": 39,
	"./oc/main.yml": 40,
	"./pl/main.yml": 41
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 156;